import React from 'react';
import { GamePlayer, GamePlayerMark } from '../../utils';

import styles from './styles.module.css';

interface TurnProps {
  turn: GamePlayer;
}

const Turn = (props: TurnProps) => {
  return (
    <div className={styles['turn']}>
      {GamePlayerMark[props.turn]}
      <h4>turn</h4>
    </div>
  );
}

export default Turn;